export default "__VITE_ASSET__BSTPuDt1__"